import axios from 'axios'
import useAxios from "../../helpers/useAxios";
import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import { formatDate, formatDateToHours, formatStatus } from "../../helpers/utils.js";
import React from "react";
import RegistarInteracao from '../forms/RegistarInteracao.js';
import close from '../../assets/images/IconXButton.png';


const DetalhePedido = (props) => {
    const { keycloak } = useKeycloak();
    
    const [interactions, setInteractions] = useState([])
    const [isLoaded, setIsLoaded] = useState(false)
    const [badgeColor, setBadgeColor] = useState()
    const [fontColor, setFontColor] = useState()


    let lastInteractioDate = ''

    const { fetch, data, error, loaded } = useAxios("POST", "/User/get-interactions", {
        Nif: keycloak.tokenParsed.preferred_username,
        TicketId: props.Detail.id
    });


    useEffect(() => {
        setIconAndColors()
        if (loaded & error.length === 0) {
            if (data.interactions) {
                setInteractions(data.interactions)
            }
            if (data === true) {
                props.SaveChanges()
            }
            setIsLoaded(true);
        }
    }, [data])

    const reopen = dataForm => {
        setIsLoaded(false);
        fetch("POST", "/User/create-interaction", {
            ClientNif: keycloak.tokenParsed.preferred_username,
            TicketId: props.Detail.id,
            Message: dataForm.comentario,
            sender: 1,  // Enviado pelo "cliente"
            status: 2   // Volta para "em progresso"
        });
    }

    const defClose = dataForm => {
        setIsLoaded(false);
        fetch("POST", "/User/update-ticket", {
            nif: keycloak.tokenParsed.preferred_username,
            id: props.Detail.id,
            status: 4, // Ticket fechado
            notes: "",
            agreed: 0, // Concorda com o fecho
            Side: 0    // Não depende de ninguém
        });
    }

    const cancelTicket = dataForm => {
        setIsLoaded(false);
        fetch("POST", "/User/create-interaction", {
            ClientNif:keycloak.tokenParsed.preferred_username,
            TicketId: props.Detail.id,
            Message: dataForm.comentario,
            sender: 1, // Enviado pelo "cliente"
            Status: 3  // Ticket cancelado
        });
    }

    const createInteraction = dataForm => {
        setIsLoaded(false);
        fetch("POST", "/User/create-interaction", {
            ClientNif: keycloak.tokenParsed.preferred_username,
            TicketId: props.Detail.id,
            Message: dataForm.comentario,
            sender: 1, // Enviado pelo "cliente"
            Status: 2  // Em progresso (ou aberto, lógica no backend)
        });
    }

    const setIconAndColors = () => {
        switch (formatStatus(props.Detail.status)) {
            case "Aberto":
                // Aberto -> Verde
                setBadgeColor('#008927');
                setFontColor('#FFFFFF');
                break;
            case "Em progresso":
                // Em progresso -> Amarelo
                setBadgeColor('#FCB732');

                setFontColor('#000000');
                break;
            case "Cancelado":
                // Cancelado -> Vermelho
                setBadgeColor('#C63A38');
                setFontColor('#FFFFFF');
                break;
            case "Fechado":
                // Fechado -> Cinza
                setBadgeColor('#CDE5F8');
                setFontColor('#000000');
                break;
            default:
                break;
        }
    }

    return (
        <div className="modal show" tabIndex={-1} role="dialog" style={{ display: 'block' }}>
            <div className="modal-dialog modal-lg  modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title"> ID {props.Detail.id} - {props.Detail.subject} </h5>
                        <button type="button" className="close-btn" onClick={props.CloseModalShow} style={{ height:'40px', width:'40px'}}>
                            <img src={close} alt="Fechar" />
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="row pb-2 mb-2 me-1 ms-1 border-bottom border-primary">
                            <div className="col-4 col-info-ttl" style={{ color: '#3F5B78' }}>
                                Estado
                            </div>
                            <div className="col-8 text-end">
                                <div>
                                    <span className="badge rounded-pill py-2 px-2" style={{ fontWeight: 'normal', fontSize: '14px', backgroundColor: badgeColor, color: fontColor }} >
                                        {formatStatus(props.Detail.status)}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="chat">
                            {interactions && interactions.length > 0 && (
                                <div className="interactions" id="inter">
                                    {interactions.map((interaction, index) => (
                                        <div key={index}>
                                            <div className={"ticketUpdateDate " + (formatDate(interaction.dateReg, '/') === lastInteractioDate ? ' ' : 'newdate')}>
                                                {lastInteractioDate = formatDate(interaction.dateReg, '/')}
                                            </div>
                                            <div className={"interaction " + (interaction.sender === 1 ? 'sender' : '')} key="{interaction.id}">
                                                {interaction.message}
                                                <div className={"interactionTime " + (interaction.sender === 1 ? 'sender' : '')}>
                                                    {formatDateToHours(interaction.dateReg)}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        {((props.Detail.status === 1 || props.Detail.status === 2 || props.AskForAgreement) &&
                            <RegistarInteracao
                                CreateInteraction={createInteraction}
                                CancelTicket={cancelTicket}
                                DefClose={defClose}
                                Reopen={reopen}
                                AskForAgreement={props.AskForAgreement}
                                TicketStatus={props.Detail.status}
                                TypingDisabled={props.TypingDisabled}
                            />)}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DetalhePedido